/* HD Produktkarte – Farbpunkte, Schnellkauf, 3D-Neigung (global, per Event-Delegation:
   funktioniert auch für Karten, die später nachgeladen werden) */
(function () {
  if (window.__HDC__) return;
  window.__HDC__ = true;

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function vars(card) {
    if (card.__hdcV) return card.__hdcV;
    var s = card.querySelector('[data-hdc-data]');
    try { card.__hdcV = s ? JSON.parse(s.textContent) : []; } catch (e) { card.__hdcV = []; }
    return card.__hdcV;
  }
  function opt(v, idx) { return idx === 0 ? v[1] : idx === 1 ? v[2] : null; }
  function ci(card) { return Number(card.getAttribute('data-ci')); }
  function si(card) { return Number(card.getAttribute('data-si')); }

  function pick(card, size) {
    var c = ci(card), s = si(card), color = card.getAttribute('data-color');
    var list = vars(card).filter(function (v) {
      return (c < 0 || opt(v, c) === color) && (s < 0 || size === '' || opt(v, s) === size);
    });
    return list.filter(function (v) { return v[3]; })[0] || list[0] || null;
  }

  function syncSizes(card) {
    var s = si(card), c = ci(card), color = card.getAttribute('data-color');
    var all = vars(card);
    card.querySelectorAll('[data-hdc-size]').forEach(function (b) {
      var size = b.getAttribute('data-hdc-size');
      var ok;
      if (size === '') {
        ok = !!pick(card, '') && pick(card, '')[3];
        b.textContent = ok ? 'In den Warenkorb' : 'Ausverkauft';
      } else {
        ok = all.some(function (v) { return v[3] && opt(v, s) === size && (c < 0 || opt(v, c) === color); });
        b.setAttribute('aria-label', size + (ok ? ' in den Warenkorb' : ' – ausverkauft'));
      }
      b.disabled = !ok;
    });
    /* Farben ohne verfügbare Größe abschwächen */
    if (c >= 0) card.querySelectorAll('[data-hdc-color]').forEach(function (d) {
      var col = d.getAttribute('data-hdc-color');
      d.classList.toggle('is-out', !all.some(function (v) { return v[3] && opt(v, c) === col; }));
    });
  }
  function ensureSync(card) { if (!card.__hdcSync) { card.__hdcSync = true; syncSizes(card); } }

  function msg(card, text, kind) {
    var m = card.querySelector('[data-hdc-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.classList.toggle('is-ok', kind === 'ok');
    m.classList.toggle('is-err', kind === 'err');
  }

  function toggleQa(card, on) {
    card.classList.toggle('is-qa', on);
    var b = card.querySelector('[data-hdc-open]');
    if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) {
      ensureSync(card);
      var first = card.querySelector('[data-hdc-size]:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    }
  }

  function widthUrl(u, w) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function swapImg(card, src) {
    var img = card.querySelector('.hdc__img--1');
    if (!img || img.getAttribute('data-cur') === src) return;
    img.setAttribute('data-cur', src);
    var set = [360, 540, 720, 900].map(function (w) { return widthUrl(src, w) + ' ' + w + 'w'; }).join(', ');
    var pre = new Image();
    pre.sizes = img.sizes; pre.srcset = set; pre.src = widthUrl(src, 720);
    img.classList.add('is-fading');
    var done = function () {
      img.srcset = set; img.src = widthUrl(src, 720);
      requestAnimationFrame(function () { img.classList.remove('is-fading'); });
      card.classList.add('is-swapped');
    };
    if (pre.decode) pre.decode().then(done, done); else pre.onload = done;
  }

  function setColor(card, color) {
    card.setAttribute('data-color', color);
    card.querySelectorAll('[data-hdc-color]').forEach(function (d) {
      var on = d.getAttribute('data-hdc-color') === color;
      d.classList.toggle('is-on', on); d.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    syncSizes(card); card.__hdcSync = true;
    var c = ci(card), list = vars(card).filter(function (v) { return opt(v, c) === color; });
    var withImg = list.filter(function (v) { return v[4]; })[0];
    if (withImg) swapImg(card, withImg[4]);
    var first = list.filter(function (v) { return v[3]; })[0] || list[0];
    if (first) {
      var url = card.getAttribute('data-url') + '?variant=' + first[0];
      card.querySelectorAll('[data-hdc-link]').forEach(function (a) { a.href = url; });
    }
  }

  function add(card, btn) {
    if (btn.disabled || btn.classList.contains('is-busy')) return;
    var v = pick(card, btn.getAttribute('data-hdc-size'));
    if (!v || !v[3]) { msg(card, 'Gerade ausverkauft.', 'err'); return; }
    btn.classList.add('is-busy'); msg(card, '');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { id: v[0], quantity: 1 };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (!res.ok || res.j.status) { msg(card, res.j.description || res.j.message || 'Das hat leider nicht geklappt.', 'err'); return; }
        btn.classList.add('is-ok');
        msg(card, '✓ Im Warenkorb', 'ok');
        card.classList.remove('is-added'); void card.offsetWidth; card.classList.add('is-added');
        if (cart && cart.renderContents && res.j.sections) { try { cart.renderContents(res.j); } catch (e) { /* Hinweis optional */ } }
        document.dispatchEvent(new CustomEvent('hd:cart-added', { detail: res.j }));
        setTimeout(function () { btn.classList.remove('is-ok'); msg(card, ''); toggleQa(card, false); }, 1800);
      })
      .catch(function () { btn.classList.remove('is-busy'); msg(card, 'Keine Verbindung. Bitte nochmal versuchen.', 'err'); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var open = t.closest('[data-hdc-open]');
    var size = t.closest('[data-hdc-size]');
    var dot = t.closest('[data-hdc-color]');
    var card = t.closest('[data-hdc]');
    document.querySelectorAll('.hdc.is-qa').forEach(function (c) { if (c !== card) toggleQa(c, false); });
    if (open && card) { e.preventDefault(); toggleQa(card, !card.classList.contains('is-qa')); return; }
    if (size && card) { e.preventDefault(); add(card, size); return; }
    if (dot && card) { e.preventDefault(); setColor(card, dot.getAttribute('data-hdc-color')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.hdc.is-qa').forEach(function (c) {
      toggleQa(c, false);
      var b = c.querySelector('[data-hdc-open]'); if (b) b.focus();
    });
  });
  document.addEventListener('focusin', function (e) {
    var card = e.target.closest && e.target.closest('[data-hdc]');
    if (card) ensureSync(card);
  });

  /* PC: Größen vorab prüfen, sobald die Maus auf die Karte kommt; 3D-Neigung + Lichtfleck */
  if (fine) {
    var cur = null, raf = 0, lastEv = null;
    var reset = function (m) { m.style.setProperty('--hdc-rx', '0deg'); m.style.setProperty('--hdc-ry', '0deg'); };
    document.addEventListener('pointerover', function (e) {
      var card = e.target.closest && e.target.closest('[data-hdc]');
      if (card) ensureSync(card);
    }, { passive: true });
    if (!reduce) {
      document.addEventListener('pointermove', function (e) {
        lastEv = e;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var m = lastEv.target.closest ? lastEv.target.closest('[data-hdc-tilt]') : null;
          if (cur && cur !== m) reset(cur);
          cur = m;
          if (!m) return;
          var r = m.getBoundingClientRect();
          var px = (lastEv.clientX - r.left) / r.width - 0.5, py = (lastEv.clientY - r.top) / r.height - 0.5;
          m.style.setProperty('--hdc-rx', (-py * 4).toFixed(2) + 'deg');
          m.style.setProperty('--hdc-ry', (px * 4).toFixed(2) + 'deg');
          m.style.setProperty('--hdc-mx', ((px + 0.5) * 100).toFixed(1) + '%');
          m.style.setProperty('--hdc-my', ((py + 0.5) * 100).toFixed(1) + '%');
        });
      }, { passive: true });
    }
  }
})();
